<style lang="css" scoped>

</style>

<template>

    <v-layout row wrap>
      <v-flex xs12 v-if="psStatus">
          <v-progress-linear v-model="passwordStrength" :color="psColor" height="20" reactive class="white--text text-xs-center" :dir="locale == 'he' ? 'rtl' : 'ltr'">{{psValue}}</v-progress-linear>
      </v-flex>
    </v-layout>

</template>

<script>
export default {
    name: 'passwordStr',
    props: ['password'],
    data() {
        return {
          locale: null,
          psStatus: false,
          passwordStrength: 0,
          psColor: 'red',
          psValue: '',
        }
    },
    methods: {
      passStrength() {
        let password = this.password;
        let strength = 0;
        if (!password || password.length < 1) {
          this.psStatus = false;
          this.passwordStrength = 0;
        } else if(password && password.length > 0) {
          if (password.length < 6) {
            this.passwordStrength = 25;
            this.psValue = this.content.psLevel[0];
            this.psColor = 'red';
          } else {
            strength += 1;
            if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)){
              strength += 1;
            }
            if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)){
              strength += 1;
            }
            if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)){
              strength += 1;
            }
            if (password.match(/(.*[!,%,&,@,#,$,^,*,?,_,~].*[!,%,&,@,#,$,^,*,?,_,~])/)){
              strength += 1;
            }
            if (strength < 2 ) {
              this.passwordStrength = 50;
              this.psValue = this.content.psLevel[1];
              this.psColor = 'amber';
            } else if (strength == 2 ) {
              this.passwordStrength = 75;
              this.psValue = this.content.psLevel[2];
              this.psColor = 'blue';
            } else {
              this.passwordStrength = 100;
              this.psValue = this.content.psLevel[3];
              this.psColor = 'green accent-4';
            }
          }
          this.psStatus = true;
        }
        this.$emit('pwdStr', this.passwordStrength);
      },
      setLang(){
        if (this.locale == "en") {
            this.content = {
                psLevel: [
                  'Too Weak',
                  'Weak',
                  'Not Bad...',
                  'Excellent!',
                ]
            };
        } else if (this.locale == "he") {
            this.content = {
                psLevel: [
                  'חלשה מידי',
                  'חלשה',
                  'לא רע...',
                  'מעולה!',
                ]
            };
        }
      },
    },
    watch: {
      password: function(val) {
        this.passStrength();
      }
    },
    created() {
      this.locale = Lang.get();
      this.setLang();
    },
    mounted() {

    },
}
</script>
